import React from 'react'
import Alert from '@material-ui/lab/Alert'
import classes from './index.module.css'

function RejectionMessage ({ header, message }) {
  return (
    <div className={classes.root}>
      <Alert severity='error'>
        <label>{header}</label>
        <div className={classes.textarea}>
          <textarea value={message} rows={5} />
        </div>
      </Alert>
    </div>
  )
}

export default RejectionMessage
